module.exports = __webpack_public_path__ + "img/icon-transfer-from-acc-to-balance.72722aa0.svg";